import script from "./GroupChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupChip.vue?vue&type=script&setup=true&lang=ts"

import "./GroupChip.vue?vue&type=style&index=0&id=bd203142&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd203142"]])

export default __exports__